import { StyledEditFarmDrawer } from './style';

interface EditFarmDrawerProps {
  isEditFarmDrawerOpen: boolean;
  setEditFarmDrawer: () => void;
  children?: React.ReactNode;
  id?: string;
  footer?: React.ReactNode;
  closeIcon?: React.ReactNode;
  destroyOnClose?: boolean;
}

const EditFarmDrawer = ({
  isEditFarmDrawerOpen,
  setEditFarmDrawer,
  children,
  footer,
  closeIcon,
  destroyOnClose,
}: EditFarmDrawerProps) => {
  return (
    <StyledEditFarmDrawer
      width={1250}
      open={isEditFarmDrawerOpen}
      onClose={setEditFarmDrawer}
      footer={footer}
      closeIcon={closeIcon}
      destroyOnClose={destroyOnClose}
    >
      {children}
    </StyledEditFarmDrawer>
  );
};

export default EditFarmDrawer;
